module.exports = __webpack_public_path__ + "img/fengmian.2eaf6b79.png";